/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {INudgeParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeParsedGameData";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {PixiesVsPiratesServerDataParser} from "../PixiesVsPiratesServerDataParser";
import {IPixiesVsPiratesGameData} from "../serverdata/IPixiesVsPiratesServerData";
import {IPixiesVsPiratesParsedServerData} from "./IPixiesVsPiratesParsedServerData";

export class PixiesVsPiratesParsedGameData extends SpinParsedGameData implements IPixiesVsPiratesParsedServerData, INudgeParsedGameData {

    private readonly _gameAreaSize:number[];
    private readonly _doReelNudge:boolean[];
    private readonly _extraSymbolsOnTop:string[][];
    private readonly _playerFSSelection:number;
    private readonly _freespinRound:number;
    private readonly _pixieFSCount:number;
    private readonly _pirateFSCount:number;
    private readonly _mysterySymbolOnReel:boolean[];
    private readonly _mysterySymbolPositions:number[];
    private readonly _mysterySymbolRevealed:string;
    private readonly _mysterySymbolSize:number[];
    private readonly _gameAreaSizeEnteringFreespin:number[];
    private readonly _rawReelsEnteringFreespin:string[][];
    private readonly _wildMultipliers:number[];
    private readonly _wildMultipliersEnteringFreespin:number[];
    private readonly _numberOfSpinsPerFSRound:number;
    private readonly _pixieCollectPositions:boolean[][];
    private readonly _pirateCollectPositions:boolean[][];
    private readonly _xWaysSymbolMayGiveWin:boolean;
    public readonly accumulatedRoundWin:number;

    public get gameAreaSize():number[] {
        return this._gameAreaSize;
    }

    public get doReelNudge():boolean[] {
        return this._doReelNudge;
    }

    public get extraSymbolsOnTop():string[][] {
        return this._extraSymbolsOnTop;
    }

    public get playerFSSelection():number {
        return this._playerFSSelection;
    }

    public get freespinRound():number {
        return this._freespinRound;
    }

    public get pixieFSCount():number {
        return this._pixieFSCount;
    }

    public get pirateFSCount():number {
        return this._pirateFSCount;
    }

    public get mysterySymbolOnReel():boolean[] {
        return this._mysterySymbolOnReel;
    }

    public get mysterySymbolPositions():number[] {
        return this._mysterySymbolPositions;
    }

    public get mysterySymbolRevealed():string {
        return this._mysterySymbolRevealed;
    }

    public get mysterySymbolSize():number[] {
        return this._mysterySymbolSize;
    }

    public get gameAreaSizeEnteringFreespin():number[] {
        return this._gameAreaSizeEnteringFreespin;
    }

    public get rawReelsEnteringFreespin():string[][]{
        return this._rawReelsEnteringFreespin;
    }

    public get wildMultipliers():number[] {
        return this._wildMultipliers;
    }

    public get wildMultipliersEnteringFreespin():number[] {
        return this._wildMultipliersEnteringFreespin;
    }

    public get numberOfSpinsPerFSRound():number {
        return this._numberOfSpinsPerFSRound;
    }

    public get pixieCollectPositions():boolean[][] {
        return this._pixieCollectPositions;
    }

    public get pirateCollectPositions():boolean[][] {
        return this._pirateCollectPositions;
    }

    public get xWaysSymbolMayGiveWin():boolean {
        return this._xWaysSymbolMayGiveWin;
    }

    constructor(rawData:IPixiesVsPiratesGameData, dataParser:PixiesVsPiratesServerDataParser) {
        super(rawData, dataParser);

        this._gameAreaSize = dataParser.parseGameAreaSize(rawData);
        this._doReelNudge = dataParser.parseDoReelNudge(rawData);
        this._extraSymbolsOnTop = dataParser.parseExtraSymbolsOnTop(rawData);
        this._playerFSSelection = dataParser.parsePlayerFSSelection(rawData);
        this._freespinRound = dataParser.parseFreespinRound(rawData);
        this._pixieFSCount = dataParser.parsePixieFSCount(rawData);
        this._pirateFSCount = dataParser.parsePirateFSCount(rawData);
        this._mysterySymbolOnReel = dataParser.parseMysterySymbolOnReel(rawData);
        this._mysterySymbolPositions = dataParser.parseMysterySymbolPositions(rawData);
        this._mysterySymbolRevealed = dataParser.parseMysterySymbolRevealed(rawData);
        this._mysterySymbolSize = dataParser.parseMysterySymbolSize(rawData);
        this._gameAreaSizeEnteringFreespin = dataParser.parseGameAreaSizeEnteringFreespin(rawData);
        this._rawReelsEnteringFreespin = dataParser.parseRawReelsEnteringFreespin(rawData);
        this._wildMultipliers = dataParser.parseWildMultipliers(rawData);
        this._wildMultipliersEnteringFreespin = dataParser.parseWildMultipliersEnteringFreespin(rawData);
        this._numberOfSpinsPerFSRound = dataParser.parseNumberOfSpinsPerFSRound(rawData);
        this._pixieCollectPositions = dataParser.parsePixieCollectPositions(rawData);
        this._pirateCollectPositions = dataParser.parsePirateCollectPositions(rawData);
        this._xWaysSymbolMayGiveWin = dataParser.parseXWaysSymbolMayGiveWin(rawData);
        this.accumulatedRoundWin = Number(rawData.accumulatedRoundWin);
    }
}